module.exports = "#loader {\n  width: 400px;\n  margin: 0 auto;\n  padding-top: 100px;\n}\n\n#loader h4 {\n  margin-left: 6px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/token/token.component.css
// module id = ./src/app/token/token.component.css
// module chunks = main